/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import { fixedBody, looseBody } from '@/utils/fn';
import styles from './index.less';

const CustomModal = ({
  title = '季度奖励获奖记录',
  children,
  okText = '知道了',
  okCallback = () => {},
  cancelCallback,
  visible = false,
  cancelText = '',
  needFixedBody = true,
}) => {
  const [innerVisibile, setInnerVisibile] = useState(visible);
  const [isClickable, setIsClickable] = useState(true);

  const innerCancelCallback = useCallback(() => {
    if (!cancelCallback || typeof cancelCallback !== 'function') {
      setInnerVisibile(false);
    } else {
      cancelCallback();
    }
  }, []);

  const handleOkClick = () => {
    if (!isClickable) return;
    okCallback();
  };

  useEffect(() => {
    setInnerVisibile(visible);
    if (needFixedBody) {
      if (visible) {
        fixedBody();
        // Prevent accidental clicks for 300ms when modal appears
        setIsClickable(false);
        setTimeout(() => setIsClickable(true), 300);
      } else {
        looseBody();
      }
    }
  }, [needFixedBody, visible]);

  return (
    <div className={`${styles['custom-modal']} ${innerVisibile ? styles['show'] : styles['hide']}`}>
      <div className={styles['modal-content']}>
        {title && <h3 className={styles['modal-title']}>{title}</h3>}
        <div className={styles['modal-body']}>
          {children}
        </div>
        <div className={`${styles['modal-btns']} ${cancelText ? styles['two-btns'] : ''}`}>
          {cancelText && (
            <button className={styles['cancel-btn']} onClick={innerCancelCallback}>
              {cancelText}
            </button>
          )}
          <button className={styles['ok-btn']} onClick={handleOkClick}>
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
};
export default CustomModal;
